// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uHx0G","title":"styles_title__QB7pf","description":"styles_description__QdRov"};